export const TEST_IDS = {
  CONTAINER: 'label-input-container',
  ADD_BUTTON: 'label-input-add-button',
  LABEL: 'label-input-label',
  CLOSE_ICON: 'label-input-close-icon',
  SELECT: 'label-input-select'
};
